import React from "react";

// not making CheckoutMobileFormModal a dynamic import as we optimise for mobile audiences and lazyloading this component will increase the load time
import CheckoutMobileFormModal from "repoV2/features/CheckoutPages/modules/CheckoutMobileFormModal/CheckoutMobileFormModal";
import { MOBILE_SCREEN_WIDTH } from "repoV2/constants/screen";
import commonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";

import CheckoutFormSectionRender from "./CheckoutFormSectionRender";
import useCheckoutFormRenderState from "../../utils/useCheckoutFormRenderState";

const CheckoutFormSectionDevice = (props: {
    showPaymentModal: boolean;
    handleClosePaymentModal: () => void;
}) => {
    const { showPaymentModal, handleClosePaymentModal } = props;

    const { formTitle } = useCheckoutFormRenderState();

    /**
     * We check the screen size, and incase we are not on a mobile screen,
     * and the payment modal state is open, then we close that state
     */
    const handleResize = (e: UIEvent) => {
        // @ts-ignore
        const screenSize = e.currentTarget?.innerWidth || 0;
        if (screenSize > MOBILE_SCREEN_WIDTH && showPaymentModal) {
            handleClosePaymentModal();
        }
    };

    // Have verified this for both mobile and desktop, for both with and without init_booking=true check
    // This never runs on mount, only on screen resize
    // Why this? On Dynamic Payment Links, in edit flow, we have an option to switch between desktop and movile view,
    // and we conditionally render the form in case of showPaymentModal flow
    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
        const screenSize = window.innerWidth || 0;
        if (screenSize > MOBILE_SCREEN_WIDTH && showPaymentModal) {
            handleClosePaymentModal();
        }

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [showPaymentModal]);

    return (
        <div>
            {/* Incase we do not have to show payment modal, we render the desktop view */}
            {!showPaymentModal ? (
                <div className={commonStyles.hideInMobile}>
                    <CheckoutFormSectionRender />
                </div>
            ) : (
                // Else, we render the form inside a modal
                <CheckoutMobileFormModal
                    isModalOpen={showPaymentModal}
                    onClose={handleClosePaymentModal}
                    title={formTitle}
                >
                    <CheckoutFormSectionRender />
                </CheckoutMobileFormModal>
            )}
        </div>
    );
};

export default CheckoutFormSectionDevice;
